import { createSelector } from 'reselect';

export const getById = ({ productTR }) => productTR.byId;
export const getIds = ({ productTR }) => productTR.list.allIds;
export const getProductTRList = createSelector([getIds, getById], (allIds, byId) => allIds.map(id => byId[id]));


export const getProductTRByProductId = (state, productId) => getProductTRList(state).filter(elem => elem.ProductId === productId);

